import { Component, NgZone, OnInit, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@services/notification.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  private readonly notificationService = inject(NotificationService);
  private readonly translateService = inject(TranslateService);
  private readonly destroy$ = new Subject<void>();
  loggedInName: string | null = null;
  notificationVisible = this.notificationService.notificationVisible;
  public unReadMsgCount = this.notificationService.unReadMsgCount;
  private readonly ngZone = inject(NgZone);
  protected zgUrls = {
    en: 'https://zhongguoremittance.com/en/home/',
    cn: 'https://zhongguoremittance.com/zh-chs/home/'
  };
  protected currentLang = this.translateService.currentLang as 'en' | 'cn';
  ngOnInit(): void {
    this.notificationService.initData();
    this.loggedInName = localStorage.getItem('user.name');
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(({ lang }) => {
      this.currentLang = lang === 'cn' ? lang : 'en';
    });
    //@ts-ignore
    window.refreshNotify = () => {
      this.ngZone.run(() => {
        // this.notificationService.setNotificationVisible(true);
        this.notificationService.checkUnreadNoti();
      }, true);
    };
    //@ts-ignore
    window.selectNotify = (id: number) => {
      this.ngZone.run(
        (id: number) => {
          this.notificationService.getDetail(id);
        },
        true,
        [id]
      );
    };
  }

  toggleNotification() {
    this.notificationService.setNotificationVisible(
      !this.notificationService.notificationVisible()
    );
    this.notificationService.openPopup();
  }
}
